@if (uploads().length > 0) {
  <section class="upload-progress-overlay" aria-live="polite">
    <header class="upload-progress-overlay__header">
      <span>{{ 'uploadProgress.header' | translate }}</span>
      <small>
        {{
          activeUploadCount() > 0
            ? ('uploadProgress.activeCount' | translate: { count: activeUploadCount() })
            : ('uploadProgress.finishingUp' | translate)
        }}
      </small>
    </header>

    <div class="upload-progress-overlay__list">
      @for (upload of uploads(); track trackByUploadId($index, upload)) {
        <article class="upload-progress-card" [class.error]="isError(upload.status)" [class.terminal]="isTerminal(upload.status)">
          <div class="upload-progress-card__row">
            <strong class="upload-progress-card__title">{{ upload.displayNameKey | translate }}</strong>
            @if (isTerminal(upload.status)) {
              <button class="upload-progress-card__dismiss" type="button" (click)="dismissUpload(upload.uploadId)">
                {{ 'default.close' | translate }}
              </button>
            }
          </div>

          <div class="upload-progress-card__file-name">{{ upload.fileName }}</div>
          <div class="upload-progress-card__status">{{ getStatusLabelKey(upload.status) | translate }}</div>

          <ol class="upload-progress-steps">
            @for (step of getStepStates(upload.status); track step.id) {
              <li class="upload-progress-step" [class]="step.cssClass">
                <span class="upload-progress-step__dot"></span>
                <span class="upload-progress-step__label">{{ step.labelKey | translate }}</span>
              </li>
            }
          </ol>
        </article>
      }
    </div>
  </section>
}
